import { render, staticRenderFns } from "./FormModalUnassignedWork.vue?vue&type=template&id=1408d452&"
import script from "./FormModalUnassignedWork.vue?vue&type=script&lang=js&"
export * from "./FormModalUnassignedWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports